import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { Loginpage } from "./Pages/Auth/Loginpage"
import { Toaster } from "react-hot-toast"
import { ProtectedAdminpage } from "./Protected routes/ProtectedAdmin"
import Adminalluserspage from "./Pages/Admin/Allusers"
import AdminOverview from "./Pages/Admin/AdminOverviewpage"
import { ProtectedStaffpage } from "./Protected routes/ProtectedRouteStaff"
import AdminReservation from "./Pages/Admin/ReservationPage"
import StaffLayout from "./Protected routes/StaffLayout"
import AdminaddNotificationpage from "./Pages/Admin/SetNotification"
import HomepageReservation from "./Pages/Homepage/Homepage"

import AllLeadsPage from "./Pages/Admin/Allleads"
import Adminaddproduct from "./Pages/Admin/Addproductpage"
import AdminDeleteorEdit from "./Pages/Admin/allproductspage"
import Admineditproductpage from "./Pages/Admin/Editproductpage"
import MenuUpload from "./Components/UploadMenuItems"
import MenuMainPage from "./Pages/Homepage/MenuMainpage"
import { OrderreviewPage } from "./Pages/Cartpage/Cartpage"
import AppLayout from "./Pages/SideMenuWrapper"
import AdminoneDeliveryorderdetailsPage from "./Pages/AdminoneDeliveryorderdetailsPage"
import DeliveryOrdersStaff from "./Pages/Staff/AlldeliveryordersStaff"
import Adminreviewspage from "./Pages/Admin/Allreviewspage"
import AdminDeliveryOrdersPage from "./Pages/Admin/DeliveryOrdersPage"
import Adminalldeliveryuserspage from "./Pages/Admin/AllDeliveryusers"
import { ProtectedOrdertype } from "./Protected routes/ProtectedOrdertype"
import DriverPage from "./Components/Admin/Driver"
import DeliveryOrdersStaff2 from "./Pages/Staff/AlldeliveryordersStaff2"
import AdminOverviewDelivery from "./Pages/Admin/AdminOverviewpageDelivery"
import AdminoneDeliveryorderdetailsPage2 from "./Pages/Admin/AdminoneDeliveryorderdetailsPage2"
import Adminaddpromo from "./Pages/Admin/AddPromopage"
import CategoriesManager from "./Components/Admin/Categories-Placement"
function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<HomepageReservation />} />
          <Route path="/Menu" element={<MenuMainPage />} />
          {/* <Route path="/Orderreview" element={<OrderreviewPage />} /> */}
          <Route path="/Login" element={<Loginpage />} />

          <Route element={<ProtectedAdminpage />}>
            <Route element={<AppLayout />}>
              <Route path="/adminaddproduct" element={<Adminaddproduct />} />
              <Route path="/adminmanagement" element={<AdminDeleteorEdit />} />
              <Route
                path="/admineditproduct/:id"
                element={<Admineditproductpage />}
              />
              <Route path="/adminaccounts" element={<AllLeadsPage />} />
              <Route path="/adminOverview" element={<AdminOverview />} />
              <Route
                path="/admindeliveryOverview"
                element={<AdminOverviewDelivery />}
              />

              <Route path="/Allcodes" element={<Adminaddpromo />} />
              <Route
                path="/CatgoriesPlacement"
                element={<CategoriesManager />}
              />

              <Route path="/allreviews" element={<Adminreviewspage />} />
              <Route
                path="/adminNotify"
                element={<AdminaddNotificationpage />}
              />
              <Route path="/admindineinusers" element={<Adminalluserspage />} />
              <Route
                path="/admindeliveryusers"
                element={<Adminalldeliveryuserspage />}
              />

              <Route path="/DineInorders" element={<AdminReservation />} />

              <Route
                path="/Deliveryorders"
                element={<AdminDeliveryOrdersPage />}
              />
            </Route>

            <Route
              path="/adminorderdetails/:id"
              element={<AdminoneDeliveryorderdetailsPage />}
            />

            <Route
              path="/adminDeliveryorderdetails/:id"
              element={<AdminoneDeliveryorderdetailsPage2 />}
            />
          </Route>

          <Route element={<ProtectedStaffpage />}>
            <Route
              path="/StaffPage/*"
              element={
                <StaffLayout>
                  <Routes>
                    <Route path="Status" element={<DeliveryOrdersStaff />} />
                    <Route path="delivery" element={<DeliveryOrdersStaff2 />} />
                  </Routes>
                </StaffLayout>
              }
            />
          </Route>

          <Route element={<ProtectedOrdertype />}>
            <Route path="/Driver" element={<DriverPage />} />
          </Route>
        </Routes>
      </Router>
      <Toaster />
    </div>
  )
}

export default App
